import { autoserialize, inheritSerialization } from 'cerialize';

import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class ImageText extends AbstractModel {
  @autoserialize
  field: string;

  @autoserialize
  value: string;
}
